import Link from "next/link"
import type { ComponentProps } from "react"

/**
 * A link to another page on this site that opens in a new tab, so someone working through their incident
 * plan never loses their place. Announced to screen readers.
 */
export function NewTabLink({ children, ...props }: Omit<ComponentProps<typeof Link>, "target" | "rel">) {
  return (
    <Link {...props} target="_blank" rel="noopener">
      {children}
      <span className="sr-only"> (opens in a new tab)</span>
    </Link>
  )
}
